export default "__VITE_PUBLIC_ASSET__034b9303__"